module.exports = __webpack_public_path__ + "static/13-b70e254d26113850b0de0c8d4baf27b6.png";